import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  templateActions,
  templateSelectors
} from '../../store/modules/template';

import { selectVideoFormatsCount } from './../../store/modules/video/selectors';

export const useWaveEventDataLoadChecker = () => {
  const currentTemplate = useSelector(templateSelectors.selectCurrentTemplate);

  const isVideoFormatsLoaded = useSelector(selectVideoFormatsCount);

  const isDataLoaded = currentTemplate && isVideoFormatsLoaded;

  return isDataLoaded;
};

export const useCurrentTemplateClear = () => {
  const dispatch = useDispatch();

  useEffect(() => () => { 
    dispatch(templateActions.clearCurrentTemplate()) 
  }, []);
};
